export default __webpack_public_path__ + "static/media/download2.bf58dd5b.jpg";